import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeId } from '../../utils/content-formatting';
import {
  ItemWrapper,
  DecorativeWrapper,
  LineTop,
  LineBottom,
  Marker,
  ContentWrapper,
  Heading,
  Content,
} from './styles';
import { VisuallyHidden } from '../styled/accessibility';

const TimelineItem = ({
  hasTimelineHeading,
  isBulletedList = true,
  heading,
  children,
  itemNumber,
}) => {
  const timelineId = sanitizeId(heading).slice(0, 30);
  const timelineHeadingId = `timeline-heading-${timelineId}`;

  return (
    <ItemWrapper aria-labelledby={timelineHeadingId}>
      <DecorativeWrapper>
        <LineTop />
        <Marker />
        <LineBottom />
      </DecorativeWrapper>

      <ContentWrapper>
        <Heading as={hasTimelineHeading ? 'h3' : 'h2'} id={timelineHeadingId}>
          {isBulletedList ? (
            ''
          ) : (
            <>
              <VisuallyHidden>Step</VisuallyHidden>
              {itemNumber}
              <span aria-hidden="true">. </span>
            </>
          )}
          {heading}
        </Heading>
        <Content id={`timeline-content-${timelineId}`}>{children}</Content>
      </ContentWrapper>
    </ItemWrapper>
  );
};

TimelineItem.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  hasTimelineHeading: PropTypes.bool,
  isBulletedList: PropTypes.bool,
  itemNumber: PropTypes.number,
};

export default TimelineItem;
